/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Account_CancelInputs */

const en_delete_account_cancel = /** @type {(inputs: Delete_Account_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const es_delete_account_cancel = /** @type {(inputs: Delete_Account_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const ar_delete_account_cancel = /** @type {(inputs: Delete_Account_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إلغاء`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Delete_Account_CancelInputs} inputs
* @param {{ locale?: "en" | "es" | "ar" }} options
* @returns {LocalizedString}
*/
export const delete_account_cancel = /** @type {((inputs?: Delete_Account_CancelInputs, options?: { locale?: "en" | "es" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Account_CancelInputs, { locale?: "en" | "es" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delete_account_cancel(inputs)
	if (locale === "es") return es_delete_account_cancel(inputs)
	return ar_delete_account_cancel(inputs)
});